import styled from '@emotion/styled';
import { colors } from '@innovationdepartment/proxima-ui';

export default styled.div`
  background-color: ${colors.white};
  border: 1px solid ${colors.neutral10};
  border-radius: 8px;
  padding: 16px;
`;
